import React from 'react';
import { Flex, Box, Image } from 'theme-ui';
import Text from '../Text';

const sizes = {
  small: {
    width: ['1em', '1.4rem'],
    height: ['1em', '1.4rem'],
    p: '2px',
  },
  medium: {
    width: ['1.2em', '1.9rem'],
    height: ['1.2em', '1.9rem'],
  },
  large: {
    width: ['2rem', '2rem'],
    height: ['2rem', '2rem'],
  },
};

export function UspWithIcon({
  usp,
  icon,
  size = 'small',
  available = true,
  stackUspText = false,
}) {
  return (
    <Flex
      sx={{
        width: '100%',
        flexDirection: stackUspText ? 'column' : 'row',
        py: 2,
        alignItems: 'center',
        color: available ? 'text' : 'accent-4',
      }}
    >
      {icon ? (
        <Image
          sx={{
            // border: (theme) => `1px solid ${theme.colors['accent-4']}`,
            // borderRadius: '100%',
            display: 'inline-flex',
            ...(sizes[size] || sizes.medium),
            flexShrink: 0,
            filter: available ? 'opacity(70%)' : 'opacity(25%)',
          }}
          src={icon.url}
        />
      ) : null}
      <Text.Span
        sx={{
          fontSize: [0],
          ml: icon ? [2, 2] : 0,
          mt: stackUspText ? 1 : 0,
          textDecoration: available ? 'none' : 'line-through',
        }}
      >
        {usp}
      </Text.Span>
    </Flex>
  );
}
const sortAvailability = (a, b) =>
  a.available === b.available ? 0 : a.available ? -1 : 1;

function UspList({ allUsps, availableUsps, ...rest }) {
  return allUsps
    .map((usp) => {
      return {
        ...usp,
        available: availableUsps.some((x) => x.id === usp.id),
      };
    })
    .sort(sortAvailability)
    .map(({ id, name, icon, available }) => {
      return (
        <UspWithIcon
          key={id}
          usp={name}
          icon={icon ? icon.image : null}
          available={available}
          {...rest}
        />
      );
    });
}

export default UspList;
